export const Marquee = ({ items, className = "" }) => {
  const doubled = [...items, ...items];
  return (
    <div className={`w-full overflow-hidden py-6 ${className}`} data-testid="brand-marquee">
      <div className="marquee-track">
        {doubled.map((item, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-heading italic text-4xl md:text-6xl font-light px-8 text-[#2A2118]">
              {item}
            </span>
            <span className="text-[#C8A98E] text-3xl">&#10022;</span>
          </span>
        ))}
      </div>
    </div>
  );
};
